import {Component, input, model, output} from '@angular/core';
import {Dialog} from 'primeng/dialog';
import {ButtonModule} from 'primeng/button';
import {TooltipModule} from 'primeng/tooltip';
import {IconBoldCloseSquareComponent} from '@components/icons/icon-bold-close-square/icon-bold-close-square.component';

@Component({
  selector: 'app-dialog',
  imports: [Dialog, ButtonModule, TooltipModule, IconBoldCloseSquareComponent],
  templateUrl: './dialog.component.html',
  standalone: true,
  styleUrl: './dialog.component.css'
})
export class DialogComponent {
  visible = model(false);
  closable = input(true);
  draggable = input(false);
  width = input('auto');
  height = input('auto');
  headerTitle = input('Confirmação');
  message = input('Deseja realmente realizar esta operação?');
  cancelLabel = input('Cancelar');
  confirmLabel = input('Confirmar');

  readonly closed = output<void>();

  onHide(event: any) {
    this.visible.set(false);
  }

  protected onCloseClick(): void {
    this.visible.set(false);
    this.closed.emit();
  }
}
